import ajax from 'api/ajax'

class MyAccount {
    // 获取厂商列表
    VendorManagement = () => ajax('api/v1/companys', {}, 'post')
    modifyPassword = (oldPassword,password,repeatePass) => ajax('login/pass-modify', {oldPassword,password,repeatePass}, 'post')

}
export default MyAccount
